export default "/_next/static/images/32eeb00998921865dd75c90f8723f964.png";